import { atom } from "jotai";
import {
  canvasAtom,
  isAiPageAtom,
  streamingProgressAtom,
  zslAtom,
} from "@zapier/canvas-state";
import { isModifyPromptOpenAtom } from "./isModifyPromptOpenAtom";

export const zslToCanvasErrorAtom = atom(null);
zslToCanvasErrorAtom.debugLabel = "zslToCanvasErrorAtom";

export const zslToCanvasPostSetter = atom(
  null,
  async (get, set, zslString: string) => {
    set(streamingProgressAtom, 0);
    set(isModifyPromptOpenAtom, false);

    const zsl = JSON.parse(zslString);
    // This supports storing the ZSL when we're creating the canvas
    set(zslAtom, zsl); // This needs to go before setting the nodes so that zapAtomFamily_SUSPENDS is getting zap data from zsl instead of trying to fetch a zap with fake _ZAP_ id

    const isAiPage = get(isAiPageAtom);

    if (isAiPage && zsl.name) {
      set(canvasAtom, (prevCanvas) => ({
        ...prevCanvas,
        name: zsl.name,
      }));
    }
  },
);

zslToCanvasPostSetter.debugLabel = "zslToCanvasPostSetter";
